import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { LimitsPerNbSteps } from '@shared/constants';
import { SvgDirective } from '@shared/directives';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant2Config } from '@shared/models';
import {
  AmountPipe,
  ProgressWidthPipe,
  RewardPipe,
  SafePipe,
  StepStatusPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-progress-section',
  styleUrl: './progress-section.component.scss',
  templateUrl: './progress-section.component.html',
  imports: [
    SafePipe,
    AmountPipe,
    RewardPipe,
    SvgDirective,
    StepStatusPipe,
    ProgressWidthPipe,
    VariableReplacementPipe,
  ],
})
export class ProgressSectionComponent extends BaseComponent {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant2Config>();

  public limitsPerNbSteps: LimitsPerNbSteps = {
    oneStep: { start: 0, end: 180 },
    twoStep: { step1: { start: 0, end: 62 }, step2: { start: 88, end: 178 } },
    threeStep: {
      step1: { start: 0, end: 24 },
      step2: { start: 53, end: 103 },
      step3: { start: 133, end: 178 },
    },
  };
}
